import React, { useState, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { assign } from 'lodash';

import { Report } from '~/components';
import { RadioGroup, Autocomplete, Input, Select } from '~/components/Form';

export default function DlgRelVeiculo() {
  const { profile } = useSelector((state) => state.user);

  const [open, setOpen] = useState(true);
  const [company, setCompany] = useState('');
  const [typeVehicle, setTypeVehicle] = useState('');

  const optionsTypeRadio = useMemo(
    () => [
      { label: 'PDF', value: 'pdf' },
      { label: 'Excel', value: 'xls' },
    ],
    []
  );

  const optionsActive = useMemo(
    () => [
      { label: 'Todos', value: ' ' },
      { label: 'Sim', value: 'S' },
      { label: 'Não', value: 'N' },
    ],
    []
  );

  const optionsOrder = useMemo(
    () => [
      { label: 'Empresa', value: 'empresa' },
      { label: 'Equipamento', value: 'equipamento' },
    ],
    []
  );

  const handleModifyReportData = useCallback(
    (data) => {
      const values = assign(
        {
          usuario: profile.username,
          strusuario: profile.name,
          empresa: '',
          veiculo: '',
          empresa_nome: company,
          tipoveiculo: '',
          tipoveiculo_nome: typeVehicle,
          idtarefapath: "dlgRelVeiculo.swf",
        },
        JSON.parse(JSON.stringify(data))
      );

      return values;
    },
    [company, typeVehicle]
  );

  return (
    <Report
      open={open}
      title="Relatório de Equipamentos"
      relatorio="VEICULO"
      onClose={() => setOpen(false)}
      serialize={handleModifyReportData}
      initials={{ ativo: ' ', ordenacao: 'empresa', tipo: 'pdf' }}
    >
      <Autocomplete
        name="empresa"
        label="empe_desc"
        url="empresa"
        unique="empe_cod_emp"
        title="Empresa"
        getValue={({ empe_desc }) => setCompany(empe_desc || '')}
      />

      <Autocomplete
        name="tipoveiculo"
        label="tive_desc"
        url="veiculo/tipos"
        unique="tive_cod_tive"
        title="Tipo de Equipamento"
        getValue={({ tive_desc }) => setTypeVehicle(tive_desc || '')}
      />

      <Input name="veiculo" type="number" label="Equipamento" />

      <Select name="ativo" label="Ativos" options={optionsActive} />

      <Select name="ordenacao" label="Ordenação" options={optionsOrder} />

      <RadioGroup
        row
        name="tipo"
        label="Formato de Saída"
        options={optionsTypeRadio}
      />
    </Report>
  );
}
